import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { getApiBaseUrl } from '../utils/vanity-url.util';
import { logWarn } from '../logging/logger.service';

@Injectable({ providedIn: 'root' })
export class GateService {
  private readonly checkUrl = `${getApiBaseUrl()}/check-gate-access`;
  private readonly loginUrl = `${getApiBaseUrl()}/gate-login`;

  constructor(private readonly http: HttpClient) {}

  getLoginUrl(): string {
    return this.loginUrl;
  }

  checkAccess(): Observable<boolean> {
    return this.http
      .get(this.checkUrl, {
        withCredentials: true,
        responseType: 'text'
      })
      .pipe(
        map(() => true),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 401) {
            const returnPath = encodeURIComponent(
              window.location.pathname + window.location.search
            );
            // Use /gate (not /gate.html). SWA pretty-URLs 301 /gate.html to the default
            // azurestaticapps.net hostname, which breaks vanity same-origin.
            window.location.href = `/gate?returnUrl=${returnPath}&apiBase=${encodeURIComponent(getApiBaseUrl())}`;
            return of(false);
          }
          logWarn('core/services/gate.service', '[GateService] check-gate-access failed with status', err.status);
          return of(true);
        })
      );
  }
}